import { makeStyles, Theme } from '@material-ui/core';
import { distances } from '../../../../../../styles';

interface StyleProps {
  width?: number;
}

export const useStyles = makeStyles<Theme, StyleProps>({
  popperV2: {
    backgroundColor: '#fff',
    border: '1px solid #EEF0F2',
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow:
      '0px 40px 80px -16px rgba(48, 54, 60, 0.14), 0px 4px 4px 0px rgba(48, 54, 60, 0.04)',
    zIndex: 1500,
    width: ({ width }) => width - 5 || 'fit-content'
  },
  popper: {
    backgroundColor: '#fff',
    border: '1px solid #1E96FC',
    borderRadius: '4px',
    zIndex: 1500,
    width: ({ width }) => width - 5 || 'fit-content'
  },
  content: {
    padding: `${distances.px.small} ${distances.px.base}`
  }
});
